<div class="content-area">
  <div class="home-content-area">
    <xproj-dashboard #dashboardOverview [editMode]="false" [showDashboardSettings]="false"
    [systemDashboard]="true" [dashboardId]="'bms_home'" [enableExport]="false"
    [dashboardTag]="'latest'" [responsiveWidth]="responsiveWidth" ></xproj-dashboard>
  </div>
</div>
